import currency from 'currency.js';

export function formatPrice(cents: number) {
  return currency(cents, {
    fromCents: true,
    symbol: '€',
    pattern: '#!',
  }).format();
}
